import { render, staticRenderFns } from "./WebSiteIcon.vue?vue&type=template&id=3ebb26cd&scoped=true"
import script from "./WebSiteIcon.vue?vue&type=script&lang=js"
export * from "./WebSiteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb26cd",
  null
  
)

export default component.exports